// extracted by mini-css-extract-plugin
export default {"editButton":"addLoans_editButton__RHyei","TableBody":"addLoans_TableBody__Y26U0","deleteButton":"addLoans_deleteButton__feuz+"};